import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

type Props = {
  onActionEditar: (IdAuditor: number | null) => void;
  onActionDeletar: (IdAuditor: number | null, openState: boolean) => void;
};

export const GenerateAuditoriaAuditoresColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  //#region  TipoAuditor
  const computeItemTipoAuditorTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Externo";
      case 0:
        return "Interno";
      default:
        return "Interno";
    }
  };
  const computeItemTipoAuditorColor = (status: number) => {
    switch (status) {
      case 0:
        return "green";
      case 1:
        return "blue";
      default:
        return "green";
    }
  };

  //#endregion

 return [
    {
      field: "TipoAuditor",
      filterable: false,
      headerName: "Auditor",
      width: 120, 
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-start items-center px-2">
          <LargeItemStatus
            title={computeItemTipoAuditorTitle(params.value)}
            color={computeItemTipoAuditorColor(params.value)}
            description=""
          />
        </div>
      ),
    },
    {
      field: "Nome",
      filterable: false,
      headerName: "Nome", 
      flex: 2, 
      minWidth: 200,
      sortable: false,
      headerClassName: "funcionarios-header",
      renderCell: (params) => (
        <div className="break-words whitespace-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "Email",
      filterable: false,
      headerName: "Email",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
          <div className="break-words whitespace-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Cidade",
      filterable: false,
      headerName: "Cidade",
      flex: 1, 
      minWidth: 120, 
      sortable: false,
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
          <div className="break-words whitespace-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "TelCelular",
      filterable: false,
      headerName: "Tel Celular",
      width: 150, 
      sortable: false,
      headerClassName: "funcionarios-header",
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "IdAuditor",
      sortable: false,
      filterable: false,
      headerName: "Ações",
      width: 100, 
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value)}>
              <DynamicIcon
                nameIcon="EditRounded"
                size={25}
                className="dark:text-white text-primary-green"
              />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={25}
                className="text-red-500"
              />
            </IconButton>
          </div>
        );
      },
    },
];
};
